import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { Component, OnInit, Renderer2, ElementRef, ViewChildren, QueryList, AfterViewInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionService } from 'src/app/service/accordion.service';

@Component({
  selector: 'formly-field-create-accordion',
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
  }],
  standalone:true,
  imports : [CommonModule,TranslateModule, FormlyModule, ReactiveFormsModule],
  template: `
    <div class="accordion mt-4" [id]="accordionId">
      <div class="accordion-item" *ngFor="let accordion of fields; let i = index"
      [ngClass]="{
       'border-left-red': isAccordionInvalid(accordion),
       'border-left-green': isAccordionValid(accordion)
     }">
        <h2 class="accordion-header" [id]="'heading_' + accordion.id">
          <button #accordionButton
                  class="accordion-button" 
                  [ngClass]="{'collapsed': !accordion.isInitiallyOpen}" 
                  type="button" 
                  data-bs-toggle="collapse" 
                  [attr.data-bs-target]="'#collapse_' + accordion.id"
                  [attr.aria-expanded]="accordion.isInitiallyOpen ? 'true' : 'false'" 
                  [attr.aria-controls]="'collapse_' + accordion.id"
                  (click)="toggleAccordion(accordion)">
            {{ accordion.props.label | translate }}
          </button>
        </h2>
        <div [id]="'collapse_' + accordion.id" 
             class="accordion-collapse collapse" 
             [ngClass]="{'show': accordion.isInitiallyOpen}" 
             [attr.data-bs-parent]="'#' + accordionId" 
             [attr.aria-labelledby]="'heading_' + accordion.id">
          <div class="accordion-body" [ngClass]="[(field.templateOptions.padding || ''), (field.templateOptions.margin || '')]" *ngIf="(field?.fieldGroup?.length > 0 || !allDefaultValuesAreDash)">
            <ng-container #fieldComponent></ng-container>
          </div>
        </div>
      </div>
      <div *ngIf="field.props.isRequired" class="text-danger">
        <small>{{ getErrorMessage(field) }}</small>
      </div>
    </div>`,
  styles: [`
    .accordion-header {
      margin: 0 !important;
    }
    .fontFamily {
      font-family: Poppins, sans-serif !important;
    }
    button {
      height: 40px !important;
    }
    .border-left-red {
  border-left: 5px solid red;
}

.border-left-green {
  border-left: 5px solid green;
}
    .accordion-button {
    &:focus{
    box-shadow : none !important;
  }
    }
  `]
})
export class CreateAccordionWrapper extends FieldWrapper implements OnInit, AfterViewInit {
  @ViewChildren('accordionButton') accordionButtons: QueryList<ElementRef>;

  fontSize: string;
  fontWeight: string;
  color: string;
  fontStyle: string;
  backgroundColor: string;
  accordionId: string;
  fields: any;
  allDefaultValuesAreDash = true;
  fontFamily: string;

  constructor(private renderer: Renderer2, private accordionService: AccordionService) { // Inject the service
    super();
  }

  ngOnInit() {
    this.fields = [this.field];
    this.accordionId = 'accordion_' + this.field.id;
    this.fontSize = this.field?.props.sectionFontSize || "15.5px";
    this.fontWeight = this.field?.props.sectionFontWeight || "400";
    this.color = this.field?.props.sectionFontColor || "rgb(139 31 25)";
    this.fontStyle = this.field?.props.sectionFontStyle || "normal";
    this.backgroundColor = this.field?.props.sectionBgColor || "rgb(241 241 241)";
    this.fontFamily = 'Poppins, sans-serif';

    // Add the current accordion to the service
    this.accordionService.addAccordion(this.field);
  }

  ngAfterViewInit() {
    this.applyStyles();
  }

  applyStyles() {
    this.accordionButtons.forEach(button => {
      button.nativeElement.style.setProperty('font-size', this.fontSize, 'important');
      button.nativeElement.style.setProperty('font-weight', this.fontWeight, 'important');
      button.nativeElement.style.setProperty('color', this.color, 'important');
      button.nativeElement.style.setProperty('font-style', this.fontStyle, 'important');
      button.nativeElement.style.setProperty('background-color', this.backgroundColor, 'important');
      button.nativeElement.style.setProperty('font-family', this.fontFamily, 'important');
    });
  }

  getErrorMessage(field) {
    return `Let's complete the ${field.props.label} field to proceed.`;
  }

  // isAccordionInvalid(accordion) {
  //   return accordion.fieldGroup.some(subField => subField.formControl.invalid && !subField.hide);
  // }

  // isAccordionValid(accordion) {
  //   return accordion.fieldGroup.every(subField => subField.formControl.valid || subField.hide);
  // }
  // isAccordionInvalid(accordion) {
  //   return accordion.fieldGroup.some(subField => subField.formControl.invalid && !subField.hide && !this.hasClass(subField, 'd-none'));
  // }

  // isAccordionValid(accordion) {
  //   return accordion.fieldGroup.every(subField => subField.formControl.valid || subField.hide || this.hasClass(subField, 'd-none'));
  // }
  isAccordionValid(accordion) {
    return accordion.fieldGroup.every(subField => 
      this.isFieldValid(subField)
    );
  }
  isAccordionInvalid(accordion) {
    return accordion.fieldGroup.some(subField => 
      this.isFieldInvalid(subField)
    );
  }
  
 
  
  // Helper function to check field validity recursively
  isFieldInvalid(field) {
    if (field.fieldGroup) {
      // Recursively check nested fieldGroups
      return field.fieldGroup.some(subField => this.isFieldInvalid(subField));
    } else {
      // Base case: check the current field
      return field.formControl.invalid && !field.hide && !this.hasClass(field, 'd-none');
    }
  }
  
  // Helper function to check field validity recursively
  isFieldValid(field) {
    if (field.fieldGroup) {
      // Recursively check nested fieldGroups
      return field.fieldGroup.every(subField => this.isFieldValid(subField));
    } else {
      // Base case: check the current field
      return field.formControl.valid || field.hide || this.hasClass(field, 'd-none')||field.templateOptions.readOnly;
    }
  }
  
  hasClass(field, className) {
    return field.className && field.className.split(' ').includes(className);
  }

  toggleAccordion(accordion) {
    this.accordionService.closeAllExcept(accordion);
    accordion.isInitiallyOpen = !accordion.isInitiallyOpen;
    if (accordion.isInitiallyOpen) {
      this.accordionService.scrollToAccordion(`heading_${accordion.id}`);
    }
  }
}